import { render, staticRenderFns } from "./SelectContact.view.vue?vue&type=template&id=4c8c3804&scoped=true"
import script from "./SelectContact.view.vue?vue&type=script&lang=js"
export * from "./SelectContact.view.vue?vue&type=script&lang=js"
import style0 from "./SelectContact.view.vue?vue&type=style&index=0&id=4c8c3804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c3804",
  null
  
)

export default component.exports